module.exports = __webpack_public_path__ + "img/sanke2.a0b8ce3c.png";